module.exports = __webpack_public_path__ + "static/img/success@2x.bfd7f454.png";